import { ApiToastHandlerOptions } from "../models"

type ToastKey = "routePlanCreate" | "routePlanUpdate" | "routePlanDelete"

export const appToastConstants: Record<ToastKey, ApiToastHandlerOptions> = {
  routePlanCreate: {
    success: { messageKey: "toastSuccess.routePlanCreate" },
  },
  routePlanUpdate: {
    success: { messageKey: "toastSuccess.routePlanUpdate" },
  },
  routePlanDelete: {
    success: { messageKey: "toastSuccess.routePlanDelete" },
  },
}
